<template>
  <ui-modal-alert
    v-bind="$attrs"
    modal-classes="staff-qr-checkin-modal"
    :title="$t('staffMembers.qrPermissions.title')"
    :apply-button="$t('staffMembers.qrPermissions.assign')"
    :apply-disabled="!selected.length"
    :close-button="$t('staffMembers.qrPermissions.skip')"
    @apply="handleApply"
    @cancel="handleCancel"
  >
    <p class="text-muted mb-3">
      {{ $t('staffMembers.qrPermissions.description') }}
    </p>

    <ui-input
      v-model="pattern"
      :placeholder="$t('form.placeholders.search')"
      input-icon="search"
      class="mb-3"
    />

    <div class="staff-qr-checkin-modal__list">
      <ui-checkbox
        class="d-flex mb-3"
        :checked="selectAll"
        @input="toggleAll"
      >
        {{ $t('staffMembers.qrPermissions.all') }}
      </ui-checkbox>

      <ui-checkbox
        v-for="code in filteredCodes"
        :key="code.id"
        class="d-flex mb-3"
        v-model="selected"
        :value="code.id"
      >
        {{ code.name || code.id }}
      </ui-checkbox>
    </div>
  </ui-modal-alert>
</template>

<script>
import api from '@/api';

export default {
  name: 'StaffQrCheckInModal',

  props: {
    staff: {
      type: Object,
      required: true,
    },
    location: {
      type: Object,
      required: true,
    },
    codes: {
      type: Array,
      required: true,
    },
  },

  data: () => ({
    selected: [],
    pattern: '',
  }),

  computed: {
    selectAll() {
      return this.codes.length > 0 && this.selected.length === this.codes.length;
    },
    filteredCodes() {
      const query = this.pattern.trim().toLowerCase();

      if (!query) {
        return this.codes;
      }

      return this.codes.filter((code) => `${code.name || code.id}`.toLowerCase().includes(query));
    },
  },

  methods: {
    toggleAll(checked) {
      this.selected = checked ? this.codes.map(({ id }) => id) : [];
    },
    async handleApply() {
      const codes = this.selectAll
        ? this.codes
        : this.codes.filter(({ id }) => this.selected.includes(id));

      try {
        await api.qrCheckin.grantStaffQrCodes({
          locationId: this.location.id,
          staffId: this.staff.id,
          codes,
        });
      } catch (e) {
        this.$showServerError(e);
      }

      // Registration itself already succeeded — finish the flow (reload the
      // list) regardless of the grant result; the error toast informs the user.
      this.$emit('apply');
    },
    handleCancel() {
      this.$emit('cancel');
    },
  },
};
</script>

<style>
.staff-qr-checkin-modal.modal-dialog-scrollable {
  height: auto;
  min-height: calc(100% - 3.5rem);
  flex-direction: column;
  justify-content: center;
}

.staff-qr-checkin-modal__list {
  height: 280px;
  overflow-y: auto;
}
</style>
